import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { LicenseImageCardComponent } from './license-image-card/license-image-card.component';
import { LicenseUploadBottomSheetComponent } from './license-upload-bottom-sheet/license-upload-bottom-sheet.component';
import { CropImageBottomSheetComponent } from './crop-image-bottom-sheet/crop-image-bottom-sheet.component';

@NgModule({
  declarations: [UploadDocumentComponent, LicenseImageCardComponent, LicenseUploadBottomSheetComponent, CropImageBottomSheetComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDatepickerModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatTooltipModule,
    MatDividerModule,
    ReactiveFormsModule,
    ImageCropperComponent
  ],
  exports: [UploadDocumentComponent, LicenseImageCardComponent, LicenseUploadBottomSheetComponent]
})
export class ComponentsModule { }

